import React, { Component} from 'react';
import * as actions from '../actions/index'

export default class Billing extends Component {
  componentWillMount() {
    this.props.dispatch(actions.setTopbarButtons([]))
  }

  render(){
    return (
      <div>
        <h3>Billing</h3>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Billing.js